import request from '@/utils/request'
// 回传配置页面顶部筛选列表
export function platformSelectList(params) {
  return request({
    url: '/novel_management/wechat_platforms',
    method: 'get',
    params
  })
}
// 获取平台下所有账号
export function getList(params) {
  return request({
    url: '/platform/py_platform_account',
    method: 'get',
    params
  })
}
// 删除某个账号
export function deleteLi(id) {
  return request({
    url: `/platform/py_platform_account/${id}`,
    method: 'delete'
  })
}

// 添加账号
export function addAccount(data) {
  return request({
    url: '/platform/py_platform_account',
    method: 'post',
    data
  })
}
// 改变账号状态
export function changeStatus(id, data) {
  return request({
    url: `/platform/py_platform_account/${id}`,
    method: 'put',
    data
  })
}

// 获取公众号
export function accountList(params) {
  return request({
    url: '/platform/py_wechat_account_crontab',
    method: 'get',
    params
  })
}

// 添加公众号
export function addAccountItem(data) {
  return request({
    url: '/platform/py_wechat_account_crontab',
    method: 'post',
    data
  })
}

// 更新公众号粉丝状态
export function updateAccount(id, data) {
  return request({
    url: `/platform/py_wechat_account_crontab/${id}`,
    method: 'put',
    data
  })
}

// 更新公众号粉丝状态
export function deleteAccount(id) {
  return request({
    url: `/platform/py_wechat_account_crontab/${id}`,
    method: 'delete'
  })
}
// 公众号组列表
export function getAccountGroup(params) {
  return request({
    url: '/novel_management/wechat_accounts',
    method: 'get',
    params
  })
}
// 公众号筛选条件列表
export function getSelectList() {
  return request({
    url: '/novel_management/novel_report_selects',
    method: 'get'
  })
}
// 公众号组下面的子列表
export function getofficialList(params) {
  return request({
    url: '/novel_management/msrelation',
    method: 'get',
    params
  })
}
// 创建公众号组绑定
export function creatAccountItem(data) {
  return request({
    url: '/novel_management/msrelation',
    method: 'post',
    data
  })
}
// 更新公众号组绑定
export function updateAccountItem(id, data) {
  return request({
    url: `/novel_management/msrelation/${id}`,
    method: 'put',
    data
  })
}
// platform/py_platform_account/38 修改密码
export function modifyPwd(id, data) {
  return request({
    url: `/platform/py_platform_account/${id}`,
    method: 'put',
    data
  })
}
// 删除公众号组绑定
export function deleteAccountItem(id) {
  return request({
    url: `/novel_management/msrelation/${id}`,
    method: 'delete'
  })
}
// 获取公众号下拉筛选项 公众号组报表使用 公众号组绑定
export function getWechataccountlist() {
  return request({
    url: '/common/wechat_account_list',
    method: 'get'
  })
}
// 获取错误信息列表
export function geterrorinform(params) {
  return request({
    url: '/platform/py_account/errinfo_detail',
    method: 'get',
    params
  })
}
// 更改错误信息状态
export function editerrorinform(data) {
  return request({
    url: '/platform/py_account/update_errinfo',
    method: 'post',
    data
  })
}
// 渠道关系列表
export function getrelationshiplist(params) {
  return request({
    url: '/novel_management/channel_msrelation',
    method: 'get',
    params
  })
}
// 渠道筛选列表
export function getselectlist(params) {
  return request({
    url: '/novel_management/channel/list',
    method: 'get',
    params
  })
}

// 渠道关系存储
export function channelstorage(data) {
  return request({
    url: '/novel_management/channel_msrelation',
    method: 'post',
    data
  })
}
// 渠道关系更新
export function updateChannel(id, data) {
  return request({
    url: `/novel_management/channel_msrelation/${id}`,
    method: 'put',
    data
  })
}
export function deleteChannel(id) {
  return request({
    url: `/novel_management/channel_msrelation/${id}`,
    method: 'delete'
  })
}

export function importR(data = {}) {
  return request({
    url: `/import/channel`,
    method: 'POST',
    data
  })
}

// 获知管理员是否超管
export function isExceeded() {
  return request({
    url: `/platform/py_sign`,
    method: 'get'
  })
}

// 获取用户列表
export function getUserList(params = {}) {
  return request({
    url: `/user/userList`,
    method: 'get',
    params
  })
}
// 系统默认充值返现活动开关
export function activeyawr(data = {}) {
  return request({
    url: `/activity/chargeReturnDefault/updateSwitch`,
    method: 'POST',
    data
  })
}
// 获取主图集数据
export function getMainAtlasData(params = {}) {
  return request({
    url: `/activity/Atlas/atlasList`,
    method: 'get',
    params
  })
}

// 获取子图集数据
export function getSubgraphSet(params = {}) {
  return request({
    url: `/activity/Atlas/atlasInfoSelect`,
    method: 'get',
    params
  })
}
// 创建订单返现活动
export function chargePacket(data = {}) {
  return request({
    url: `/activity/chargePacket/create`,
    method: 'POST',
    data
  })
}
// 订单返现活动列表
export function chargePacketlist(params = {}) {
  return request({
    url: `/activity/chargePacket/list`,
    method: 'get',
    params
  })
}

// 系统默认充值返现活动的比例
export function chargeReturnDefault(params = {}) {
  return request({
    url: `/activity/chargeReturnDefault/proItems`,
    method: 'get',
    params
  })
}
// 系统默认充值返现活动创建
export function chargeReturnDefaultcreate(data = {}) {
  return request({
    url: `/activity/chargeReturnDefault/create`,
    method: 'POST',
    data
  })
}
// 用户订单列表
export function userOrders(params = {}) {
  return request({
    url: `/user/userOrders`,
    method: 'get',
    params
  })
}

